import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { HeaderUser } from './../header-user';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { CommonService } from '@service/common.service';
import { ApiV6Service } from '@service/apiv6.service';
import { lastValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-edit-user',
    templateUrl: './edit-user.component.html',
    styleUrls: ['./edit-user.component.scss'],
})
export class EditUserComponent implements OnInit {
    public dataItem: HeaderUser;
    public resultResult: any[];

    @Input()
    public item: any;

    @Input()
    public userListDelegate: any;

    @Input()
    public groupListBase: any;

    @Input()
    public duplicate : boolean = false;

    @Output() 
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDeleteItem: EventEmitter<any> = new EventEmitter();
    
    @Output()
    public onLoadItem: EventEmitter<any> = new EventEmitter();


    public userListDelegateUse = [];

    constructor(
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        public menu: MenuServiceInt,
        private commonService: CommonService,
        private translate: TranslateService
    ) {
        this.menu.display = true;
        this.dataItem = new HeaderUser();
    }

    ngOnInit() {
        this.getData(this.item);
        this.commonService.checkReset();
        this.userListDelegateUse = [];
        this.userListDelegateUse = this.userListDelegate.filter(item => {
            if (item.value !== this.item.reference) {
                return item;
            }
        });
    }

    private async getData(item) {
        let wRes: any;
        const wdata = { user: item.reference };
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('getuserdata', wdata));
            this.dataItem.Clear();
            if (item.id !== 0) {
                this.loadData(wRes.UserData);
            }
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        }
    }

    private loadData(adata) {
        this.dataItem.duplicate = this.duplicate;
        this.dataItem.loadData(adata);
        this.onLoadItem.emit({ index: this.item.index, id: this.item.id });
    }

    delete(data) {
        data.login = this.dataItem.login;
        this.onDeleteItem.emit({ index: this.item.index, id: this.item.id, data: data });
    }

    public async validate(data) {
        let wRes: any;
        if (this.dataItem.duplicate === true) {
            // id de la requête forcé à 0 : duplication
            data.id = 0;
            data.data.id = 0;
            data.data.autogenerated = false;
        } else {
            data.id = -1;
        }
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('setuserdata', data ));
            this.onValidate.emit({ index: this.item.index, id: this.item.id, data: wRes, duplicate: this.dataItem.duplicate });
        } catch (error) {
            console.log('Error', error);
            if (error.error.Message === 'Exist') {
                this._messageService.addWarn(this.translate.instant('Cf_UserExist', {user: data.data.login}));
            } else {
                if (error.error.CodeMessage === 'Pass_KO') {
                    this._messageService.addErrorMsg(error.error.Message);
                } else {
                    this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
                }                
            }
        }
    }

    cancel(event) {
        this.onCancel.emit({ index: this.item.index, id: this.item.id });
    }
}
